import type { Organization } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";

import { getFormattedParticipationLinkedProjectsNames } from "../../../utils/get-formatted-participation-linked-projects-names";

export function ParticipationHoldingNameWithLinkedProjects({
  organization,
  className,
}: {
  organization: Organization;
  className?: string;
}) {
  return (
    <span className={cn("flex items-center gap-x-2 text-black", className)}>
      <span className="body300-regular lg:max-w-52">{organization.name}</span>
      <span className="body100-regular text-pretty lg:max-w-[263px]">
        {getFormattedParticipationLinkedProjectsNames(
          organization.linkedProjectsViaVehicle,
        )}
      </span>
    </span>
  );
}
